/**
 * Ad Block Wonder — content and ad blocker
 *
 * Declares one web-accessible-resource group listing ~24 explicit files (popup scripts,
 * the startup page, scriptlet code and blocklist detail JSON), matched to `<all_urls>`
 * with no `use_dynamic_url` — so each is fetchable from any page at a fixed URL.
 *
 * The exposed phishing icon is the cleanest signal: an image loaded through `probeImage`
 * with no CORS grant, surviving a restrictive page CSP. A successful load is conclusive —
 * the file is served only when the extension is installed.
 *
 * Manifest verified against version 5.8.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'fpkbnjejghdcncegfglnapabnljcimdc';

export const adBlockWonder: ExtensionDefinition = {
  id: ID,
  name: 'Ad Block Wonder',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    '~24 explicit WAR on <all_urls>, no dynamic URL. The phishing icon loads via <img> ' +
    'with no CORS grant, corroborated by the vendor-specific scriptlet and startup paths.',
  signals: [
    {
      id: 'war-phishing-icon',
      kind: 'web-accessible-resource',
      description:
        'Load popup/img/phishing-128.png via <img> — exposed to every origin and ' +
        'readable without a CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'popup/img/phishing-128.png'),
    },
    {
      id: 'war-scriptlet-adjust-timers',
      kind: 'web-accessible-resource',
      description:
        'Fetch src/blocker/scriptlet/codes/adjust-timers.min.js — a vendor-specific ' +
        'scriptlet path, distinctive to this blocker and independent of the icon.',
      weight: 0.5,
      run: () => probeFetch(ID, 'src/blocker/scriptlet/codes/adjust-timers.min.js'),
    },
    {
      id: 'war-startup-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch startup/startup.html — the static startup page, a third independent path ' +
        'exposed to every origin.',
      weight: 0.5,
      run: () => probeFetch(ID, 'startup/startup.html'),
    },
  ],
};
